import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getMe, getSurveyProgress } from '../../api';
import { EnterpriseContext } from '../../contexts/EnterpriseContext';
import './index.css';
import './index.tablet.css';
import './index.mobile.css';

export default function FamilyFriendly() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [enterprise, setEnterprise] = useState(null);
  const [surveyProgress, setSurveyProgress] = useState(null);

  useEffect(() => {
    getMe()
      .then((res) => setEnterprise(res.result))
      .catch(() => navigate('/login'));
  }, [navigate]);

  useEffect(() => {
    if (!enterprise) return;
    getSurveyProgress()
      .then((res) => setSurveyProgress(res.result?.surveyProgress ?? 0))
      .catch(() => setSurveyProgress(0));
  }, [enterprise]);

  const isQuestionnairePending = surveyProgress !== null && surveyProgress < 2;

  const navItems = [
    { to: '/family-friendly/overview', label: t('ff.nav.overview') },
    {
      to: '/family-friendly/questionnaire',
      label: t('ff.nav.questionnaire'),
      badge: isQuestionnairePending ? t('ff.nav.badge.pending') : null,
    },
    { to: '/family-friendly/company-info', label: t('ff.nav.companyInfo') },
  ];

  return (
    <EnterpriseContext.Provider value={{ enterprise, surveyProgress, setEnterprise }}>
      <div className="ff-page-container">
        <div className="ff-page">
          <div className="ff-sidebar">
            {navItems.map((item) => {
              const isActive =
                location.pathname === item.to || location.pathname.startsWith(item.to + '/');
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={`ff-sidebar-item ${isActive ? 'ff-sidebar-item--active' : ''}`}
                >
                  <span className="ff-sidebar-item-label">{item.label}</span>
                  {item.badge && <span className="ff-sidebar-badge">{item.badge}</span>}
                </NavLink>
              );
            })}
          </div>
          <div className="ff-content">
            <Outlet />
          </div>
        </div>
      </div>
    </EnterpriseContext.Provider>
  );
}
